var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgODailyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1035_198",
    maskUnits: "userSpaceOnUse",
    x: 0.5,
    y: 0,
    width: 16,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.5,
    width: 16,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2C1.5 1.44772 1.94772 1 2.5 1H14.5C15.0523 1 15.5 1.44772 15.5 2V10.5C15.5 11.0523 15.0523 11.5 14.5 11.5H2.5C1.94772 11.5 1.5 11.0523 1.5 10.5V2ZM4.125 1.875H2.375V3.625L4.125 1.875ZM14.625 1.875H12.875L14.625 3.625V1.875ZM4.125 10.625H2.375V8.875L4.125 10.625ZM14.625 10.625H12.875L14.625 8.875V10.625Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 1.875V0.875H1.375V1.875H2.375ZM4.125 1.875L4.83211 2.58211L6.53921 0.875H4.125V1.875ZM2.375 3.625H1.375V6.03921L3.08211 4.33211L2.375 3.625ZM12.875 1.875V0.875H10.4608L12.1679 2.58211L12.875 1.875ZM14.625 1.875H15.625V0.875H14.625V1.875ZM14.625 3.625L13.9179 4.33211L15.625 6.03921V3.625H14.625ZM2.375 10.625H1.375V11.625H2.375V10.625ZM4.125 10.625V11.625H6.53921L4.83211 9.91789L4.125 10.625ZM2.375 8.875L3.08211 8.16789L1.375 6.46079V8.875H2.375ZM12.875 10.625L12.1679 9.91789L10.4608 11.625H12.875V10.625ZM14.625 10.625V11.625H15.625V10.625H14.625ZM14.625 8.875H15.625V6.46079L13.9179 8.16789L14.625 8.875ZM2.5 0C1.39543 0 0.5 0.89543 0.5 2H2.5V2V0ZM14.5 0H2.5V2H14.5V0ZM16.5 2C16.5 0.89543 15.6046 0 14.5 0V2H16.5ZM16.5 10.5V2H14.5V10.5H16.5ZM14.5 12.5C15.6046 12.5 16.5 11.6046 16.5 10.5H14.5V12.5ZM2.5 12.5H14.5V10.5H2.5V12.5ZM0.5 10.5C0.5 11.6046 1.39543 12.5 2.5 12.5V10.5H2.5H0.5ZM0.5 2V10.5H2.5V2H0.5ZM2.375 2.875H4.125V0.875H2.375V2.875ZM3.375 3.625V1.875H1.375V3.625H3.375ZM3.41789 1.16789L1.66789 2.91789L3.08211 4.33211L4.83211 2.58211L3.41789 1.16789ZM12.875 2.875H14.625V0.875H12.875V2.875ZM15.3321 2.91789L13.5821 1.16789L12.1679 2.58211L13.9179 4.33211L15.3321 2.91789ZM13.625 1.875V3.625H15.625V1.875H13.625ZM2.375 11.625H4.125V9.625H2.375V11.625ZM1.375 8.875V10.625H3.375V8.875H1.375ZM4.83211 9.91789L3.08211 8.16789L1.66789 9.58211L3.41789 11.3321L4.83211 9.91789ZM12.875 11.625H14.625V9.625H12.875V11.625ZM13.9179 8.16789L12.1679 9.91789L13.5821 11.3321L15.3321 9.58211L13.9179 8.16789ZM15.625 10.625V8.875H13.625V10.625H15.625Z",
    fill: "#F99C39",
    fillOpacity: 0.53,
    mask: "url(#path-1-outside-1_1035_198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56425 8.84875L10.6392 10.1038C11.0192 10.3337 11.4842 9.99375 11.3842 9.56375L10.8342 7.20375L12.6692 5.61375C13.0042 5.32375 12.8242 4.77375 12.3842 4.73875L9.96925 4.53375L9.02425 2.30375C8.85425 1.89875 8.27425 1.89875 8.10425 2.30375L7.15925 4.52875L4.74425 4.73375C4.30425 4.76875 4.12425 5.31875 4.45925 5.60875L6.29425 7.19875L5.74425 9.55875C5.64425 9.98875 6.10925 10.3287 6.48925 10.0988L8.56425 8.84875Z",
    fill: "#F99C39",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgODailyIcon);
export default __webpack_public_path__ + "static/media/o_daily_icon.21dcd5dcde73604651877211b9966fc3.svg";
export { ForwardRef as ReactComponent };